import React, { useContext } from 'react';
import { Grid, TextField, Button, MenuItem } from '@mui/material';
import { SearchOutlined as SearchIcon, AddOutlined as AddIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { usersContext } from '../UsersContext';


let Filters = () => {
    let service = useContext(usersContext);


    return (
        <>
            <Grid item xs={2}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search"
                    value={service.search.fullText}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        fullText: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs>
                <Button
                    type="submit"
                    variant="outlined"
                    aria-label="search"
                    onClick={() => service.doSearch(service.search)}
                >
                    <SearchIcon />
                </Button>
            </Grid>
            <Grid item>
                <TextField
                    select
                    label="Order by"
                    fullWidth
                    size="small"
                    sx={{ minWidth: 160 }}
                    value={service.search.orderBy}
                    onChange={(e) => {
                        service.doSearch({
                            ...service.search,
                            orderBy: e.target.value
                        });
                    }}
                >
                    <MenuItem value={'Name'}>Name</MenuItem>
                    <MenuItem value={'LastLoginDate'}>Last login</MenuItem>
                </TextField>
            </Grid>
            <Grid item>
                <Button
                    variant="contained"
                    color="inherit"
                    component={Link}
                    to={'/admin/user/addnew'}
                >
                    <AddIcon />&nbsp;Add New
                </Button>
            </Grid>
        </>
    );
}

export default Filters;